export interface CreateOrganizationChecklistDto {
    name: string;
    tasks: string[];
    flis: string[];
    originalChecklistId: string;
}
